import Vuex from 'vuex';
import Vue from 'vue';
import createPersistedState from 'vuex-persistedstate';

import VueCookie from 'vue-cookie';

Vue.use(Vuex);
Vue.use(VueCookie);


export default new Vuex.Store({
  plugins: [
    createPersistedState({
      storage: {
        getItem: key => Vue.cookie.get(key),
        setItem: (key, value) =>
          Vue.cookie.set(key, value, { expires: 3, secure: false }),
        removeItem: key => Vue.cookie.delete(key)
      }
    })
  ],
  state: {
    user_id: 0,
    user: null,
    is_teacher: false,
    group_person_id: 0,
    group_id: 0,
    tabIndexPills: 0,
    //typeScheduled: 0,
    datosSidebar: null,
    is_representative: false,
    is_admin:false,
    flag_subject :false,
    classRequestTab: true,
    updateViewStudent : false,
    flagPostulant : false,
    flagValidateCalifications  : false,
    flagViewModalTimeZone: true,
    authToken: null,
    is_group: false,
    isAlertWindow:false
  },
  mutations: {
    mutateIsAlertWindow: function (state, payload) {
      state.isAlertWindow = payload;
    },
    mutateUserId: function (state, payload) {
      state.user_id = payload;
    },
    mutateUser: function (state, payload) {
      state.user = payload;
    },
    mutateIsTeacher: function (state, payload) {
      state.is_teacher = payload;
    },
    mutateTabIndex: function (state, payload) {
      state.tabIndexPills = payload;
    },
    
    mutateDatosSidebar: function (state, payload) {
      state.datosSidebar = payload;
    },
    mutateGroupPersonId: function (state, payload) {
      state.group_person_id = payload;
    },
    mutateGroupId: function (state, payload) {
      state.group_id = payload;
    },
    mutateIsRepresentative: function (state, payload) {
      state.is_representative = payload;
    },
    mutateIsAdmin: function (state, payload) {
      state.is_admin = payload;
    },
    mutateClassRequestTab: function (state, payload) {
      state.classRequestTab = payload;
    },

    mutateUpdateViewStudent : function (state,payload){
      state.updateViewStudent = payload
    },
    mutateUpdateFlagSubject : function (state,payload){
      state.flag_subject = payload
    },
    mutateFlagPostulant : function (state,payload){
      state.flagPostulant = payload
    },
    mutateFlagValidateCalifications : function (state,payload){
      state.flagValidateCalifications = payload
    },
    mutateFlagViewModalTimeZone: function (state, payload){
      state.flagViewModalTimeZone = payload;
    },
    mutateAuthToken: function (state, payload){
      state.authToken = payload;
    },
    mutateIsGroup: function (state, payload){
      state.is_group = payload;
    }
  },
  actions: {
    updateIsAlertWindow: function ({ commit }, payload) {
      commit('mutateIsAlertWindow', payload);
    },
    updateUserIdAction: function ({ commit }, payload) {
      commit('mutateUserId', payload);
    },
    updateUserAction: function ({ commit }, payload) {
      commit('mutateUser', payload);
    },
    updateIsTeacher: function ({ commit }, payload) {
      commit("mutateIsTeacher", payload);
    },
    updateGroupPersonId: function ({ commit }, payload) {
      commit("mutateGroupPersonId", payload);
    },
    updateGroupId: function ({ commit }, payload) {
      commit("mutateGroupId", payload);
    },
    updateDatosSidebar: function ({ commit }, payload) {
      commit("mutateDatosSidebar", payload);
    },
    updateIsRepresentative: function ({ commit }, payload) {
      commit("mutateIsRepresentative", payload);
    },
    updateIsAdmin: function ({ commit }, payload) {
      commit("mutateIsAdmin", payload);
    },
    updateClassRequestTab: function ({ commit }, payload) {
      commit("mutateClassRequestTab", payload);
    },
    updateUpdateViewStudent: function ({commit},payload){
      commit("mutateUpdateViewStudent",payload)
    },
    updateUpdateFlagSubject: function ({commit},payload){
      commit("mutateUpdateFlagSubject",payload)
    },
    updateFlagPostulant: function ({commit},payload){
      commit("mutateFlagPostulant",payload)
    },
    updateFlagValidateCalifications: function ({commit},payload){
      commit("mutateFlagValidateCalifications",payload)
    },
    updateFlagViewModalTimeZone: function ({commit},payload){
      commit("mutateFlagViewModalTimeZone", payload)
    },
    updateAuthToken: function ({commit},payload){
      commit("mutateAuthToken", payload)
    },
    updateIsGroup: function ({commit},payload){
      commit("mutateIsGroup", payload)
    }
  },
  //plugins: [createPersistedState()],
  modules: {}
});
